export const FAKE_LINK = 'https://fake.link/1A2B3C';
